import React from 'react';

import {AlertTriangleIcon} from '@src/components/icons';

import * as S from './FormErrorMessage.styles';

export interface FormErrorMessageProps {
  message: string;
}

const FormErrorMessage = ({message}: FormErrorMessageProps) => (
  <S.Wrapper className="FormErrorMessageStyles__Wrapper">
    <AlertTriangleIcon />
    <S.Message>{message}</S.Message>
  </S.Wrapper>
);

export default FormErrorMessage;
